import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';

const useStyles = makeStyles((theme) => ({
   card: {
      padding: '10px',
      border: 'solid red 1px',
   },
   descContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   loading: {
      height: '300px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
   },
   usedPointFlag: {
      width: 10,
      height: 10,
      backgroundColor: '#EC068D',
      borderRadius: '2px',
   },
   remainPointFlag: {
      width: 10,
      height: 10,
      backgroundColor: '#CCCCCC',
      borderRadius: '2px',
   },
   tablesContainer: {
      height: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [totalPoint, setTotalPoint] = useState();
   const [rawPoints, setRawPoints] = useState();
   const [walletLeaderBoards, setWalletLeaderBoards] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { totalPoint, rawPoints, walletLeaderBoards } = JSON.parse(report);
         setTotalPoint(totalPoint);
         setRawPoints(rawPoints);
         setWalletLeaderBoards(walletLeaderBoards);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   const getChartsOptionsDefault = () => {
      return {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'item',
            formatter: '<strong>{a}</strong> <br/>{b}: {d}%',
         },
         legend: {
            top: '5%',
            left: 'center',
         },
         series: [
            {
               type: 'pie',
               radius: ['30%', '50%'],
               avoidLabelOverlap: false,
               label: {
                  formatter: '{b}\n{d}%',
               },
               color: ['#EC068D', '#CCCCCC'],
               data: [],
            },
         ],
      };
   };
   const mapOptions = (item) => {
      let options = getChartsOptionsDefault();
      options.series[0].name = item.walletName;
      options.series[0].data = [
         {
            name: 'คะแนนที่ใช้',
            value: item.usedPoints,
         },
         {
            name: 'คะแนนคงเหลือ',
            value: item.remainPoints,
         },
      ];
      const isAllZero = options.series[0].data.every(
         (item) => item.value === 0,
      );
      options.series[0].data = options.series[0].data.map((item) => {
         return {
            ...item,
            itemStyle: { color: isAllZero ? '#CCCCCC' : undefined },
         };
      });
      return options;
   };
   const calculatePercent = (a, b) => {
      let result = ((a / b) * 100).toFixed(2);
      return isNaN(result) ? '-' : result + '%';
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>
                  เปรียบเทียบคะแนนทั้งหมดและคะแนนที่ใช้ไป
               </div>
               <div className='content'>
                  ปี : {totalPoint && totalPoint.year}
                  <table className='normal'>
                     <tr>
                        <th>ประเภท</th>
                        <th>คะแนนทั้งหมด</th>
                        <th>ใช้ไป P</th>
                        <th>ใช้ไป GSB Way of Work</th>
                        <th>ใช้ไปหลักเกณฑ์</th>
                        <th>คงเหลือ</th>
                        <th>อัพเดทล่าสุดเมื่อ</th>
                     </tr>
                     {totalPoint && totalPoint.hrPoints && (
                        <tr>
                           <td>HR</td>
                           <td class='text-right'>
                              {costFormat(totalPoint.hrPoints.totalReceived)}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalBankWalletUsed,
                              )}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalEmployeeUsed,
                              )}
                           </td>
                           <td class='text-right'>
                              {costFormat(totalPoint.hrPoints.totalRuleUsed)}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalRemainingPoints,
                              )}
                           </td>
                           <td>{totalPoint.hrPoints.updateTimeLabel}</td>
                        </tr>
                     )}
                  </table>
                  <table className='normal' style={{ marginTop: '10px' }}>
                     <tr>
                        <th>ประเภท</th>
                        <th>คะแนนทั้งหมด</th>
                        <th>ใช้ไป</th>
                        <th>คงเหลือ</th>
                        <th>อัพเดทล่าสุดเมื่อ</th>
                     </tr>
                     {totalPoint &&
                        totalPoint.allPoints &&
                        totalPoint.allPoints
                           .sort((a, b) => {
                              const order = { P: 0, B: 1, G: 2, S: 3 };
                              return order[a.currency] - order[b.currency];
                           })
                           .map((item, index) => {
                              const currencyTextMap = {
                                 G: 'with GOVERNANCE',
                                 S: 'through DIGITALIZATION',
                                 B: 'for SOCIETY',
                              };
                              const displayCurrency =
                                 currencyTextMap[item.currency] ||
                                 item.currency;

                              return (
                                 <tr key={index}>
                                    <td>{displayCurrency}</td>
                                    <td className='text-right'>
                                       {costFormat(item.totalReceived)}
                                    </td>
                                    <td className='text-right'>
                                       {costFormat(item.totalRedeem)}
                                    </td>
                                    <td className='text-right'>
                                       {costFormat(item.totalRemainingPoints)}
                                    </td>
                                    <td>{item.updateTimeLabel}</td>
                                 </tr>
                              );
                           })}
                  </table>
               </div>
               <div className='sub-title'>สรุปการใช้คะแนน</div>
               <div className={classes.graphsContainer}>
                  {rawPoints &&
                     rawPoints.map((item, index) => (
                        <Box
                           key={index}
                           width={'50%'}
                           style={{ padding: '5px' }}
                        >
                           <Box
                              style={{
                                 border: 'solid 1px grey',
                                 padding: '5px',
                              }}
                           >
                              <Box fontSize={16} fontWeight={'bold'}>
                                 {item.walletName}
                              </Box>
                              <Box fontSize={16}>
                                 อัตราคะแนนทั้งหมดเทียบกับคะแนนที่ใช้ไป
                              </Box>
                              <ReactECharts
                                 option={mapOptions(item)}
                                 style={{ height: 250, width: '100%' }}
                              />
                              <Box fontSize={16}>
                                 <Box
                                    display='flex'
                                    alignItems='center'
                                    justifyContent='space-between'
                                 >
                                    <Box display='flex' alignItems='center'>
                                       <Box
                                          className={classes.usedPointFlag}
                                          mr={1}
                                       />
                                       คะแนนที่ใช้
                                    </Box>
                                    <Box fontWeight={'bold'}>
                                       {costFormat(item.usedPoints)}
                                    </Box>
                                 </Box>
                                 <Box
                                    display='flex'
                                    alignItems='center'
                                    justifyContent='space-between'
                                 >
                                    <Box display='flex' alignItems='center'>
                                       <Box
                                          className={classes.remainPointFlag}
                                          mr={1}
                                       />
                                       คะแนนคงเหลือ
                                    </Box>
                                    <Box fontWeight={'bold'}>
                                       {costFormat(item.remainPoints)}
                                    </Box>
                                 </Box>
                              </Box>
                           </Box>
                        </Box>
                     ))}
               </div>
            </div>
         </div>
         <div className='page' id='2'>
            <div className='subpage'>
               <div>
                  {walletLeaderBoards && (
                     <div>
                        <div className='title'>
                           {walletLeaderBoards[0].name}
                        </div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อกระเป๋า HR</th>
                              <th>คะแนน</th>
                           </tr>
                           {walletLeaderBoards[0].wallets.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.nameTh}</td>
                                 <td class='text-right'>
                                    {costFormat(item.point)}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {walletLeaderBoards && (
                     <div>
                        <div className='title'>
                           {walletLeaderBoards[1].name}
                        </div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อกระเป๋าธนาคาร</th>
                              <th>คะแนน</th>
                           </tr>
                           {walletLeaderBoards[1].wallets.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.nameTh}</td>
                                 <td class='text-right'>
                                    {costFormat(item.point)}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className='page' id='3'>
            <div className='subpage'>
               <div style={{ marginTop: '10px' }}>
                  {walletLeaderBoards && (
                     <div>
                        <div className='title'>
                           {walletLeaderBoards[2].name}
                        </div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อกิจกรรม</th>
                              <th>คะแนน</th>
                           </tr>
                           {walletLeaderBoards[2].wallets.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.nameTh}</td>
                                 <td class='text-right'>
                                    {costFormat(item.point)}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {walletLeaderBoards && (
                     <div>
                        <div className='title'>
                           {walletLeaderBoards[3].name}
                        </div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>รายชื่อ</th>
                              <th>คะแนน</th>
                           </tr>
                           {walletLeaderBoards[3].wallets.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.nameTh}</td>
                                 <td class='text-right'>
                                    {costFormat(item.point)}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
